import { render, staticRenderFns } from "./VHeader.vue?vue&type=template&id=2807551a&scoped=true&"
import script from "./VHeader.vue?vue&type=script&lang=js&"
export * from "./VHeader.vue?vue&type=script&lang=js&"
import style0 from "./VHeader.vue?vue&type=style&index=0&id=2807551a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2807551a",
  null
  
)

export default component.exports